<div class="acs-page">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="acs-page__loading">
    <acs-loading-spinner size="large" message="Loading member chapter dues data..."></acs-loading-spinner>
  </div>

  <!-- Error State -->
  <acs-alert 
    *ngIf="error" 
    type="error" 
    title="Error Loading Member Chapter Dues"
    [message]="error" 
    [dismissible]="true"
    (dismissed)="error = null">
  </acs-alert>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">Member Chapter Dues</h1>
        <p class="acs-page-header__subtitle">
          Detailed view of chapter dues by individual members with payment tracking and outstanding amounts. 
          <span class="acs-page-header__role">Current user: {{ currentUser.FirstLast || 'User' }} ({{ userRole }})</span>
        </p>
      </div>
    </div>

    <!-- <acs-summary 
      [summaryCards]="summaryCards"
      [gridColumns]="4"
      cardSize="medium"
      spacing="normal" /> -->


    <!-- Member Dues Data Grid Section -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">Member Dues Directory</h2>
        <p class="acs-grid-section__description">
          Complete directory of all member chapter dues with detailed payment information and management capabilities.
          Select multiple records to perform bulk operations.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          #duesGrid
          [serverSide]="true"
          [entityName]="entityName"
          entityAdapter="member-chapter-dues"
          [columns]="gridColumns"
          [pageSize]="50"
          [currentPage]="1"
          [showPagination]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[25, 50, 100, 250]"
          [sortable]="true"
          [filterable]="true"
          [enableDropdownFilters]="true"
          [searchable]="true"
          searchPlaceholder="Search by chapter name, member name, email, or member ID..."
          [selectable]="'none'"
          [exportable]="true"
          [exportFilenamePrefix]="'member-chapter-dues'"
          [stickyHeader]="true"
          [autoLoad]="true"
          emptyText="No member dues records found"
          (serverError)="onServerDataError($event)" >
        </acs-data-grid>
      </div>
    </div>
  </div>

</div>